// 药店建档变更日志列表
<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <!-- 标题 -->
    <div class="page-title-box">
      <div class="page-back" @click="$router.go(-1)">返回</div>
      <div class="page-title">{{ customerName }}-变更日志</div>
    </div>
    <!-- 查询 -->
    <SearchView :page="page" @getData="getData" @empty="empty"></SearchView>
    <!-- 表格内容 -->
    <TableView
      :page="page"
      :configName="'TZYDJD_CONFIG'"
      :path="'/fillingLogDetail'"
      @getData="getData"
      :tableData="tableData"
      v-loading.fullscreen.lock="fullscreenLoading"
    ></TableView>
  </div>
</template>
<script>
import SearchView from './components/SearchView';
import TableView from './components/TableView';
import mixins from './mixins/mixins'
export default {
  components: {
    SearchView,
    TableView,
  },
  mixins:[mixins],
  data() {
    return {
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        objectType: '1', //对象类型，1终端药店
        objectGuid: '',
        staffKey: '', //变更人
        updateTimeStart: '',
        updateTimeEnd: '',
        operateType: null, //变更方式(1新建,2变更,3删除,4导入)
        alterFieldContent: '', //变更内容
        excludeOperateType: [3], //排除状态
      },
    };
  },
  created() {},
  methods: {
    empty() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        objectType: '1', //对象类型，1终端药店
        objectGuid: this.page.objectGuid,
        staffKey: '', //变更人
        updateTimeStart: '',
        updateTimeEnd: '',
        operateType: null, //变更方式(1新建,2变更,3删除,4导入)
        alterFieldContent: '', //变更内容
        excludeOperateType: [3], //排除状态
      };
      this.timeList = [];
      this.getData({ timeList: [], flg: 1 });
    },
  },
};
</script>
<style scoped>
/* 标题 */
.page-title-box {
  height: 44px;
  line-height: 44px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  box-sizing: border-box;
  background: #ffffff;
  border-bottom: 1px solid #d9d9d9;
}
.page-back {
  width: 60px;
  height: 28px;
  line-height: 28px;
  border-radius: 2px;
  cursor: pointer;
  border: 1px solid #d9d9d9;
}
.page-title {
  flex: 1;
  font-size: 16px;
  text-align: center;
}
</style>
